// extracted by mini-css-extract-plugin
export default {"navbarTransparent":"style_navbarTransparent__eBcpT","navbarSolid":"style_navbarSolid__lqS7f","logo1":"style_logo1__bWR3k","logo2":"style_logo2__fkbGc"};